// What still stands between an entry and Submit. The button used to just go grey: a contributor
// with one video out of 27 that had silently not saved had no way to tell which one it was.
//
// Its own module so it can be unit tested (see canDeliver.js), and the single source for
// useCanContinue so the hint can never disagree with the button.
export function missingAnswers(answers) {
	const required = [
		...(answers.files ?? []).map(file => [file, !file.key]),
		...(answers.dropDowns ?? []).map(dropDown => [dropDown, !dropDown.value]),
		...(answers.dropDownsMultiple ?? []).map(dropDown => [dropDown, dropDown.value.length === 0]),
		...(answers.textFields ?? []).filter(value => value.required).map(textField => [textField, !textField.value]),
		...(answers.lists ?? []).map(list => [list, list.value.length < list.min]),
	];

	return {
		total: required.length,
		missing: required.filter(([, isMissing]) => isMissing).map(([input]) => input.name),
	};
}

// Names only once few are left: on a fresh 27-input form, a list of 27 is noise.
const MAX_NAMED = 3;

export function missingAnswersHint({total, missing}) {
	if (missing.length === 0) {
		return null;
	}
	if (missing.length <= MAX_NAMED) {
		return "Still needed: " + missing.join(", ");
	}
	return `${missing.length} of ${total} still needed`;
}
